import { useEffect, useState } from 'react';

import './DropDownRegistration.css';

import { useTranslation } from 'react-i18next';

import { Alert } from '../../../shared/components/alert/Alert';
import ModalTrigger from '../../../shared/modal/ModalTrigger';

export function DropDownRegistration(props) {
  const [dropDownTitle, setDropDownTitle] = useState('');
  const [focus, setFocus] = useState('');
  const [hasError, setHasError] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (props.activeItem) {
      setDropDownTitle(props.activeItem.replace(/&amp;/g, '&'));
    }
  }, [props.activeItem]);

  useEffect(() => {
    if (props.hasError !== undefined) {
      setHasError(props.hasError);
    }
  }, [props.hasError]);

  const handleChange = (event) => {
    setDropDownTitle(event.target.value);
    props.setActiveItem(event.target.value, event.target.id);
    // Clear error when user makes a selection
    if (event.target.value && hasError) {
      setHasError(false);
    }
  };

  return (
    <fieldset className="rdrop_down_wrapper" aria-labelledby={`${props.selectId}-label`}>
      <div className="dropdown_label_container">
        <label className="not_logged_label" htmlFor={props.selectId} id={`${props.selectId}-label`}>
          {hasError && <span className="error-indicator">{t('error')}</span>}
          {props.placeholder}
          {props.required && t('input.label.required')}
        </label>
        {props.wtfText && (
          <ModalTrigger
            modalText={props.wtfText}
            onOpenModal={props.onOpenModal}
            registration
            question={props.placeholder?.toLowerCase()?.replace(/ /g, '_')}
            questionTitle={props.placeholder}
          />
        )}
      </div>
      <div className={`custom_select ${focus}`}>
        <select
          id={props.selectId}
          value={dropDownTitle}
          onChange={handleChange}
          onFocus={() => setFocus('focus')}
          onBlur={() => setFocus('')}
          aria-required={props.required || false}
          aria-invalid={hasError}
        >
          <option disabled value="" className="disabled">
            {props.placeholder}
          </option>
          {props.data &&
            props.data.map((item, index) => (
              <option key={index} id={item.id} value={item.title} className="r_drop_down_content">
                {item.title.replace(/&amp;/gi, '&')}
              </option>
            ))}
        </select>
      </div>
      {hasError && props.errorMessage && (
        <Alert
          id={`${props.selectId}-error-alert`}
          isVisible={hasError}
          message={props.errorMessage}
          type="error"
          size="sm"
        />
      )}
    </fieldset>
  );
}
